<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <div class="card-body">
          <list-voucher :do-update="reloadVoucher" v-on:updated="updateVoucherDone" :clientId="clientId" :visitId="visitId"></list-voucher>
        </div>
      </div>
      <div class="col-md-4">
        <add-voucher :client-id="clientId" :visit-id="visitId" v-on:update="updateVoucher" :copied-voucher="voucherToCopy"></add-voucher>
      </div>
    </div>
    <div class="card-body bg-light">
<!--      <list-previous-voucher v-on:copied="copyVoucher"></list-previous-voucher>-->
    </div>
  </div>
</template>

<script>
  import apiMixin from '@/mixins'
  // import ListVoucher from './ListVoucher.vue'
  import ListVoucher from '@/views/Voucher/ListVoucher.vue'
  import ListPreviousVoucher from './ListPreviousVoucher.vue'
  import AddVoucher from '@/views/Voucher/AddVoucher.vue'

  export default {
    data () {
      return {
        reloadVoucher: false,
        voucherToCopy: false,
        // actual anamnesis
        actualClientAnamnesis: false,
        actualClientAnamnesisError: false,
        actualClientAnamnesisPending: false,
        actualClientAnamnesisDone: false,
        //
        pharmAnamnesis: false,
        allergicAnamnesis: false
      }
    },
    mixins: [apiMixin],
    methods: {
      updateVoucher () {
        this.reloadVoucher = true
      },
      updateVoucherDone () {
        this.reloadVoucher = false
      },
      copyVoucher (voucher) {
        this.voucherToCopy = voucher
      },
      updateVouchers () {
        this.reloadVoucher = true
        this.updateVoucher()
      }
      // updateVoucherDone () {
      //   this.reloadVoucher = false
      // }
    },
    computed: {
      visitId () {
        return this.$route.params.visitid
      },
      clientId () {
        return this.$route.params.clientid
      }
    },
    watch: {
      actualClientAnamnesis (val) {
        if (val) {
          this.pharmAnamnesis = false
          this.allergicAnamnesis = false
          val.forEach((element) => {
            if (element.anamnesis_type.id === 6 && element.text !== '') {
              this.pharmAnamnesis = element
            }
            if (element.anamnesis_type.id === 5 && element.text !== '') {
              this.allergicAnamnesis = element
            }
          })
        }
      }
    },
    mounted () {
      this.getActualClientAnamnesis(this.$route.params.clientid)
    },
    components: {
      ListVoucher,
      ListPreviousVoucher,
      AddVoucher
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Visit/components/VisitVoucher.vue?56797f23